export class FileSystem {

    public static downloadFileByGenerateHref(url, is_target = false) {
        const el = document.createElement('a');
        document.body.appendChild(el);
        el.setAttribute('style', 'display: none');
        el.href = url;
        el.download = url;
        if (is_target) {
            el.target = '_blank';
        }
        el.click();
        el.remove(); // remove the element
    }

    public static downloadFileByRedirctOnUrl(url, is_target = false) {
        window.open(url, '_blank');
    }
}